import cx from 'classnames'
import type React from 'react'
import { forwardRef, useRef, useState } from 'react'

import css from './Radio.module.scss'
import type { Classnames, InputType, Props } from './types'

const Radio: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<Props & InputType> & React.RefAttributes<{}>
> = forwardRef(
  (
    {
      classnames,
      disabled,
      name,
      label,
      onChange,
      size = 'large',
      initialValue = '',
      ...props
    },
    _ref
  ) => {
    const [value, setValue] = useState(initialValue)

    const inputRef = useRef<HTMLInputElement>(null)

    const classes: Classnames = {
      container: cx(
        css.container,
        disabled && css.disabled,
        size && css[size],
        classnames?.container
      ),
      input: cx(css.input, classnames?.input),
    }

    const onChangeHandle = (val: string) => {
      setValue(val)

      onChange?.({
        [name]: val,
      })
    }

    if (disabled) {
      return (
        <div className={classes.container}>
          <label className={classes.input}>
            <input {...props} type="radio" value={value} ref={inputRef} />
            <span className={css.radio} />
            <span className={css.label}>{label}</span>
          </label>
        </div>
      )
    }

    return (
      <div className={classes.container}>
        <label className={classes.input}>
          <input
            {...props}
            name={name}
            type="radio"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChangeHandle(e.target.value)
            }
            value={value}
            ref={inputRef}
          />
          <span className={css.radio} />
          <span className={css.label}>{label}</span>
        </label>
      </div>
    )
  }
)

export default Radio
